import { graphql } from "../gql";

export const createDirectoryMutationDoc = graphql(`
  mutation createDirectory($input: CreateDirectoryInput!) {
    createDirectory(input: $input) {
      ...DirectoryFragment
    }
  }
`);
